import { Divider, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import Line from "../../../Components/Line";
import { Box } from "@mui/system";
import Insurance from "./Insurance";
import { makeStyles } from "@mui/styles";
import TPA from "./TPA/TPA";

const useStyles = makeStyles({
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
      color: "white",
      backgroundColor: "#414851",
      borderRadius: "6px",
      minHeight: "35px",
      maxHeight: "35px",
      fontSize: "15px",
      fontFamily: "poppins",
      textTransform: "capitalize",
    },
    "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root": {
      textTransform: "capitalize",
      fontFamily: "poppins",
    },
  },
});

export default function InsuranceHome() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const tabContents = [<Insurance />, <TPA />];
  const classes = useStyles();
  return (
    <Grid
      sx={{
        width: "77%",
        padding: "0px 25px",
      }}
    >
      <Grid
        sx={{
          width: "100%",
          backgroundColor: "#f9fbfc",
          padding: "20px",
          position: "relative",
        }}
      >
        <Grid lg={12} item container>
          <Grid lg={6}>
            <div className="App">
              <Tabs
                className={classes.tabs}
                value={activeTab}
                onChange={handleTabChange}
                variant="standard"
                indicatorColor="transparent"
                TabScrollButtonProps={{ style: { backgroundColor: "black" } }}
              >
                <Tab
                  className={
                    activeTab === 0 ? "active-tab-button" : "tab-button"
                  }
                  label="Insurance"
                />
                <Tab
                  className={
                    activeTab === 1 ? "active-tab-button" : "tab-button"
                  }
                  label="TPA"
                />
              </Tabs>
            </div>
          </Grid>
        </Grid>
        <Divider />
      </Grid>
      <Grid
        sx={{
          width: "100%",
          padding: " 0px 0px",
          height: "80vh",
          backgroundColor: "#f9fbfc",
          "&::-webkit-scrollbar": {
            width: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "lightgray",
            visibility: "hidden",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "gray",
          },
        }}
      >
        <Box className="tab-content">{tabContents[activeTab]}</Box>
      </Grid>
    </Grid>
  );
}
